import axios from "axios";
import { getToken, ShowErrorAlert } from "../views/Common/GlobalSession";
export const getEntityExperienceApi = async (id) => {
  try {
    // Get the authentication token
    let tokenStr = getToken();
    var randomnumber = Math.floor(Math.random() * 100);
    // headers: {"Authorization" : `Bearer ${tokenStr}`}
    const response = await axios({
      method: "GET",
      url:
        process.env.REACT_APP_API_END_POINT +
        "/getEntityExperience/" +
        id +
        "?v=" +
        randomnumber,
      // data: {"id":obj.id},
      //config: { headers: {'Content-Type': 'multipart/form-data' }}
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Authorization: `Bearer ${tokenStr}`,
      },
    })
      .then((Response) => Response)
      .then((res) => {
        return res.data;
      });
    return response;
  } catch (e) {
    console.log(e);
    if (e.response && e.response.status === 401) {
      ShowErrorAlert(4, e.response.data.error.message);
    }
  }
};

export const updateEntityExperienceApi = async (updateDetails) => {
  try {
    // Get the authentication token

    // headers: {"Authorization" : `Bearer ${tokenStr}`}
    let tokenStr = getToken()
    const response = await axios({
      method: "POST",
      url: process.env.REACT_APP_API_END_POINT + "/updateEntityExperienceTag/",
      data: updateDetails,
      config: { headers: { "Content-Type": "application/json" } },
      headers:{ Authorization: `Bearer ${tokenStr}` },
    })
      .then((Response) => Response)
      .then((res) => {
        // console.log(res.data);
        return res.data;
      });
    return Promise.resolve(response);
  } catch (e) {
    console.log(e);
    if (e.response && e.response.status === 401) {
      ShowErrorAlert(4, e.response.data.error.message);
    }
    Promise.reject();
  }
};
export default getEntityExperienceApi;
